export default __webpack_public_path__ + "static/media/el_5.10fa031b.mp3";